var exports = {
  "kL": "xdbfd91f1--796c50--container",
  "Ke": "xdbfd91f1--796c50--phone_button_container",
  "lZ": "xdbfd91f1--796c50--phone",
  "wH": "xdbfd91f1--796c50--phone--m",
};

module.exports = exports;
